import { RouteConfig } from 'vue-router';

import { multiGuard } from '../Middleware/MultiGuard';
import { permissionCalendar } from '../Middleware/permission/Calendar';

import { onboardingCalendar } from '../Middleware/onboarding/index';

export const NAME_ROUTES_CALENDAR = {
  CALENDAR: 'calendario',
  TUTORIAL: 'TutorialCalendar'
};

export const Calendar: Array<RouteConfig> = [
  {
    path: '/calendario',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CALENDAR.CALENDAR,
        component: () => import(
          /* webpackChunkName: "calendar" */ '@/pages/Calendar/index.vue'
        ),
        meta: { title: 'Calendário' },
        beforeEnter: multiGuard([
          permissionCalendar,
          onboardingCalendar
        ])
      },
      {
        path: 'tutorial',
        name: NAME_ROUTES_CALENDAR.TUTORIAL,
        component: () => import(
          /* webpackChunkName: "doubts-calendar" */ '@/pages/Calendar/pages/TutorialCalendar/TutorialCalendar.vue'
        ),
        meta: { title: 'Tutorial Calendário' }
        // beforeEnter: multiGuard([
        //   permissionCalendar,
        //   onboardingCalendar
        // ]),
      }
    ]
  }
];
